import { Link, Text } from '@blueprint/ui';
import { FC } from 'react';
import { Container, DiscoverHeader } from './DiscoverMore.styles';
import { MAIN_SITE_LINK } from '../../../constants';

type Props = {
    searchArea: string | null;
    housePricesUri: string | null;
    findAgentsUri: string | null;
};

export const DiscoverMore: FC<Props> = ({
    searchArea,
    housePricesUri,
    findAgentsUri
}) => {
    return searchArea && housePricesUri && findAgentsUri ? (
        <Container>
            <DiscoverHeader size="7">
                Discover more property information on Zoopla.
            </DiscoverHeader>
            <Text size="8">
                Explore{' '}
                <Link
                    key="prices"
                    href={`${MAIN_SITE_LINK}${housePricesUri}`}
                    data-testid="house-prices-link"
                >
                    house prices in {searchArea}
                </Link>{' '}
                and{' '}
                <Link
                    key="agents"
                    href={`${MAIN_SITE_LINK}${findAgentsUri}`}
                    data-testid="find-agents-link"
                >
                    find {searchArea} agents
                </Link>
            </Text>
        </Container>
    ) : null;
};
